import React, { createContext, useContext, useEffect, useReducer, useState } from 'react';
import { NotificationContextStateInterface } from './interfaces';
import reducerAuth from './reducer';
import { NOTIFICATIONS } from './types';
import { channel } from '../../App';
import useNotificationService from '../../app/services/hooks/useNotificationService';
import { ServiceResponse } from '../../app/services/shared/interfaces';
import { AuthContext } from '../AuthContext';
import NotificationModal from '../../components/NotificationModal';
import { use } from 'echarts';
import { useLocation } from "react-router-dom";

const initialState: NotificationContextStateInterface = {
    notifications: []
};

export const NotificationContext = createContext<NotificationContextStateInterface & {
    modalVisible: boolean;
    modalType: 'warning' | 'restrictive' | null;
    modalMessage: string;
    closeModal: () => void;
    setModalVisible: (visible: boolean) => void;
    setModalType: (type: 'warning' | 'restrictive' | null) => void;
    setModalMessage: (message: string) => void;
}>(initialState as any);

const NotificationProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(reducerAuth, initialState);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalType, setModalType] = useState<'warning' | 'restrictive' | null>(null);
    const [modalMessage, setModalMessage] = useState('');
    const location = useLocation(); // Obtiene la URL actual
    const { getNotificationsNotViewed } = useNotificationService();
    const { auth } = useContext(AuthContext);

    useEffect(() => {
        if (auth) {
            getNotifications();
            channel.bind('notify', function (data: any) {
                getNotifications();
            });
        }
    }, [auth]);



    const getNotifications = () => {
        getNotificationsNotViewed({
            onSuccess: (response: ServiceResponse) => {
                dispatch({
                    type: NOTIFICATIONS,
                    payload: response.data.notifications
                });
            }
        });
    };

    const closeModal = () => {
        setModalVisible(false);
        setModalType(null);
        setModalMessage('');
    };

    return (
        <NotificationContext.Provider
            value={{
                ...state,
                modalVisible,
                modalType,
                modalMessage,
                closeModal,
                setModalVisible,
                setModalType,
                setModalMessage
            }}
        >
            {children}
            <NotificationModal />
        </NotificationContext.Provider>
    );
};

export default NotificationProvider;
